import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../pin.svg';

const ThemedPin = styled(Icon)(({ theme }) => {
    return {
        height: '24px',
        width: '24px',
        '& path': {
            stroke: theme?.colors?.icons || colors.icons,
            strokeWidth: '2px',
            fill: colors.icons,
        },
        '& line': {
            stroke: theme?.colors?.icons || colors.icons,
            fill: colors.icons,
        },
    };
});
const Pin: FC = ({ ...rest }) => {
    return <ThemedPin {...rest} />;
};

export default Pin;
